import { columnType } from '../../Columns'
import { AcceptedValueType } from '../../ValueTypes'


const columnsDescription = [
    {name: 'nameWorkplace2', type: columnType.Text},
    {name: 'totalEmployeesWorkplace2', type: columnType.Text},
    {name: "totalFemaleEmployeesWorkplace2", type: columnType.Text},
    {name: "totalEmployeesSeniority0To5Workplace2", type: columnType.Text},
    {name: "totalEmployeesSeniority5To10Workplace2", type: columnType.Text},
    {name: "totalEmployeesSeniority10To20Workplace2", type: columnType.Text},
    {name: "totalEmployeesSeniority20Workplace2", type: columnType.Text},
]

  const modelDescription = {
    nameWorkplace2: AcceptedValueType.String,
    totalEmployeesWorkplace2: AcceptedValueType.int,
    totalFemaleEmployeesWorkplace2: AcceptedValueType.int,
    totalEmployeesSeniority0To5Workplace2: AcceptedValueType.int,
    totalEmployeesSeniority5To10Workplace2: AcceptedValueType.int,
    totalEmployeesSeniority10To20Workplace2: AcceptedValueType.int,
    totalEmployeesSeniority20Workplace2: AcceptedValueType.int,
  }

var masterConfig = {
    entityName: "model::entities::companyWorkplace",
    columnsConfig: 
    {
        visibleColumns: columnsDescription,
        columnActions: 
        {
            edit : {isActive: true},
            details: {isActive: true},
            delete: {isActive: true},
        }
    },
    modelDescription: modelDescription,
}

export {masterConfig};